<!-- #63 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        {{ +$route.params.id > 0 ? "Edit" : "Add a new" }} vendor
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="pb-0">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ +$route.params.id > 0 ? "Edit" : "Add" }}
          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-form ref="form">
          <h3>Vendor Info</h3>
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="editedItem.vendor_name"
                label="Vendor Name"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Vendor name is required.',
                ]"
                class="required"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete
                label="Vendor Type"
                :items="vendorTypes"
                v-model="editedItem.vendor_type_id"
                :rules="[(v) => !!v || 'Type is required.']"
                class="required"
                item-text="text"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(editedItem.vendor_start_date)"
                    label="Start Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    :rules="[(v) => !!v || 'Start Date is required.']"
                    class="required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  required
                  v-model="editedItem.vendor_start_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete
                v-if="$route.params.id > 0"
                label="Status"
                :items="statusList"
                v-model="editedItem.status"
                :rules="[(v) => !!v || 'Status is required.']"
                class="required"
                item-text="text"
                item-value="value"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                label="Status"
                :items="statusesList"
                v-model="editedItem.status"
                :rules="[(v) => !!v || 'Status is required.']"
                class="required"
                item-text="text"
                item-value="value"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="$route.params.id > 0"
          color="primary"
          @click="save"
          :loading="loader"
          class="ma-2"
          >Update</v-btn
        >
        <v-btn
          v-else
          color="primary"
          @click="save"
          :loading="loader"
          class="ma-2"
          >Save</v-btn
        >

        <v-btn class="ml-3" color="error" @click="cancel()"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["trackCategories"]),
    formTitle() {
      return this.editedIndex === -1 ? "Create" : "Edit";
    },
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },

  data: () => ({
    start_date: null,
    dateMenu: false,
    editedIndex: -1,
    editedItem: {
      vendor_name: "",
      vendor_type_id: "",
      vendor_start_date: "",
      id: "",
    },
    defaultItem: null,
    vendorTypes: [{ text: "Warehouse", value: 1 }],
    statusesList: [{ text: "Active", value: 1 }],
    statusList: [
      { text: "Active", value: "1" },
      { text: "Inactive", value: "0" },
    ],
  }),

  watch: {},
  mounted() {},
  created() {
    this.defaultItem = Object.assign({}, this.editedItem);
    if (this.$route.params.id > 0) {
      this.getVendorDetails();
    }
  },

  methods: {
    ...mapActions([
      "getClients",
      "createOtVendor",
      "updateOtVendor",
      "snackBar",
      "getOtVendorDetails",
    ]),
    cancel() {
      this.$router.push("/vendor/list");
    },

    getVendorDetails() {
      this.getOtVendorDetails(this.$route.params.id).then((res) => {
        this.editedItem.id = this.$route.params.id;

        this.editedItem = res.data.records[0];
        this.editedItem.status = this.editedItem.status.toString();
      });
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;

      if (+this.$route.params.id) {
        this.editedItem.status = Number(this.editedItem.status);
        this.updateOtVendor({
          id: this.$route.params.id,
          data: this.editedItem,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/vendor/list");
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.createOtVendor(this.editedItem)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("/vendor/list");
            this.close();
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
